<template>
  <div class="main-wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/app/overview">
        <i class="fa fa-chart-bar"></i>
        <p>{{ $t("common.labels.dashboard") }}</p>
      </sidebar-link>
      <hr />
      <sidebar-link to="/app/admin/users" v-access-control="'ADMIN'">
        <i class="fa fa-user"></i>
        <p>{{ $t("app.labels.users") }}</p>
      </sidebar-link>
      <sidebar-link to="/app/company">
        <i class="fa fa-bank"></i>
        <p>{{ $t("app.labels.companies") }}</p>
      </sidebar-link>
      <sidebar-link to="/app/company_goodie">
        <i class="fa fa-gift"></i>
        <p>{{ $t("app.labels.company_goodie") }}</p>
      </sidebar-link>
      <hr />
      <sidebar-link to="/app/product">
        <i class="fa fa-shopping-cart text-primary"></i>
        <p>{{ $t("app.labels.products") }}</p>
      </sidebar-link>
      <sidebar-link to="/app/goodie">
        <i class="fa fa-gift text-success"></i>
        <p>{{ $t("app.labels.goodies") }}</p>
      </sidebar-link>
      <sidebar-link to="/app/regles_de_points">
        <i class="fa fa-sort-numeric-asc" aria-hidden="true"></i>
        <p>Règles de points</p>
      </sidebar-link>
      <sidebar-link to="/app/stage">
        <i class="fa fa-sort-numeric-asc" aria-hidden="true"></i>
        <p>{{ $t("app.labels.stages") }}</p>
      </sidebar-link>
      <sidebar-link to="/app/barcode">
        <i class="fa fa-barcode"></i>
        <p>{{ $t("app.labels.barcodes") }}</p>
      </sidebar-link>
      <sidebar-link to="/app/distributor">
        <i class="fa fa-check"></i>
        <p>{{ $t("app.labels.distributors") }}</p>
      </sidebar-link>
      <hr />
      <sidebar-link to="/app/history">
        <i class="fa fa-history"></i>
        <p>{{ $t("app.labels.history") }}</p>
      </sidebar-link>
      <sidebar-link to="/app/scan_verification_request">
        <i class="fa fa-search text-info"></i>
        <div class="text-truncate">
          {{ $t("app.labels.scan_verification_requests") }}
        </div>
      </sidebar-link>
      <sidebar-link to="/app/contact">
        <i class="fa fa-envelope"></i>
        <p>{{ $t("app.labels.contacts") }}</p>
      </sidebar-link>
      <sidebar-link class="d-none" to="/app/page">
        <i class="fa fa-file"></i>
        <p>{{ $t("app.labels.page") }}</p>
      </sidebar-link>

      <sidebar-link to="/app/scan_log">
        <i class="fa fa-list"></i>
        <p>{{ $t("app.labels.scan_log") }}</p>
      </sidebar-link>
      <sidebar-link to="/app/setting">
        <i class="fa fa-cog"></i>
        <p>Versions de l'app</p>
      </sidebar-link>
      <!-- <hr> -->
      <!-- <h4 class="ml-3">{{ $t('common.labels.dynamicPages') }}</h4>
      <sidebar-link
      :to="'/app/crud/' + model.name"
      v-for="model of $store.state.data.models"
      :key="model.name"
      >
      <i class="nc-icon nc-circle-09"></i>
      <p>{{ model.title }}</p>
    </sidebar-link>-->
      <!-- <hr> -->
      <li v-access-control="'DEVELOPER'" @click="loadDynamicPages()" class="">
        <a class="nav-link">
          <p>{{ $t("common.menus.loadDynamicPages") }}</p>
        </a>
      </li>
      <hr />
      <p
        v-access-control="'DEVELOPER'"
        style="
          position: absolute;
          bottom: 1px;
          font-size: 10px;
          padding: 2px 5px;
        "
      >
        Version: {{ config.version }}<br />
        Built: {{ config.buildDate }}
      </p>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click="toggleSidebar"></dashboard-content>
      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu.vue";
import config from "@/config/index.js";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },
  data() {
    return {
      config,
    };
  },

  mounted() {},
  methods: {
    loadDynamicPages() {
      this.$store.dispatch("getDynamicPages");
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
